import { types } from "mobx-state-tree";

import GenericJSONPrimitive from "./GenericJSONPrimitive";

const Event = types.model({
    id: types.identifier,
    timestamp: types.string,
    kind: types.string,
    meta: GenericJSONPrimitive,
});

const Timeline = types.model({
    id: types.identifier,
    event_set: types.array(Event),
});

export { Event, Timeline };
